import ContentManagement from "./content-management.page";

export default ContentManagement;
